import React, { useEffect, useRef, useState, memo } from 'react';
import FooterSection from "../Components/FooterSection";
import Header from '../Components/Header';
import PageTitleSection from "../Components/PageTitleSection";
import PlainContent from "../Components/PlainContent";
import HttpHelper from '../service/httpService';
import { handleImageError } from 'base/Utility'

const TrailBossNews = () => {

    const [news, setNews] = useState({});

    const getNewsList = async (data) => {
        await HttpHelper.get("Website/GetNewsList", data).then((response) => {
            setNews(response.data);
        })
    }

    useEffect(() => {
        getNewsList();
    }, []);

    return (
        <>
            <Header />
            <PageTitleSection title="Trailboss Enterprises Inc."
                subtitle={news && news.length > 0 ? news[0].heading : ''} />

            <section className={`section section-padding-bottom-90`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
    
                        <div>
                            {
                                <div className="news-content table-responsive" dangerouslySetInnerHTML={{ __html: news && news.length > 0 ? news.filter(x => x.isHeaderSection === true)[0].content : '' }}></div>
                            }
                        </div>
                        <div className="mb-xl-20 mt-xl-20">
                            {
                                news != null && news.length > 0 ? news.map((news, index) => {
                                    if (!news.isHeaderSection) {
                                        return (
                                            <div className="row mb-5">
                                                <div className="col-md-12">
                                                    <h3 className="mb-5" style={{ backgroundColor: '#d8e4df', padding: '5px' }}><b>{news.heading}</b></h3>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="scrollbar-thin m-5" style={{ maxHeight: '180px', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: news.content }}></div>
                                                </div>
                                                <div className="col-md-4">
                                                    <img src={news.file ? news.file.fileUrl : ''} width="400" height="250" onError={handleImageError} />
                                                </div>
                                            </div>
                                        )
                                    }
                                }) : null
                            }
                        </div>

                 
                        </div>
                    </div></div>
            </section>


            <FooterSection />
        </>
    )
}

export default memo(TrailBossNews);